import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';
import { toNumber } from 'lodash';

import { api } from '@/api';
import { API_URL } from '@/dtos';

const GET_EXISTING_POLICIES_KEY = 'GET_EXISTING_POLICIES_KEY';
const ACTIVE_STATUS = 'ACTIVE';

const useGetExistingPoliciesQuery = (employeeId?: string) => {
  const { isLoading, isSuccess, data } = useQuery(
    [GET_EXISTING_POLICIES_KEY, employeeId],
    () =>
      api.get(API_URL.POLICIES, {
        params: {
          employee_id: toNumber(employeeId),
        },
      }),
    {
      enabled: Boolean(employeeId),
    }
  );

  const hasActivePolicy = useMemo(
    () => data?.data?.some((item) => item?.enrollment_status === ACTIVE_STATUS),
    [data]
  );

  return {
    isLoading,
    isSuccess,
    hasActivePolicy,
  };
};

export default useGetExistingPoliciesQuery;
